export const DOMAIN = {
  VA: 'project.larksuite.com',
  EXTERNAL: 'project.feishu.cn',
  BOE_EXTERNAL: 'project.feishu-boe.cn',
};
export const API_HOST_MAP: Record<string, string> = {};

export const IS_TRIAL_DEMO = false;

export const TRIAL_DEMO_ABILITIES = {
  // 工作台
  WORKBENCH: true,
  // 团队
  TEAM: true,
  // 切换空间
  SWITCH_SPACE: true,
  // 分享
  SHARE: true,
  // 复制链接
  COPY_LINK: true,
  // 群聊：建群/加群/群空间
  CHAT_GROUP: true,
  // 新建空间
  CREATE_NEW_PROJECT: true,
  // 综搜
  GLOBAL_SEARCH: true,
  // 个人中心
  USER: true,
  // 帮助中心
  HELPCENTER: true,
  // 空间设置
  SETTING: true,
  // 全景视图
  MULTI_PROJECT_VIEW: true,
  // 度量图表
  CHART: true,
  // 催一催
  URGE: true,
  // 复制并同步
  SYNCHRONOUS_CREATION: true,
  // 复制ID
  COPY_ID: true,
  // 工作项 - 我收藏的
  WORKITEM_FAVORITE_TAB: true,
  // 导出
  EXPORT_CSV: true,
  // 工作项 - 路由按钮
  WORK_ITEM_ROUTER_BUTTONS: true,
  // 工作项 - Collect PIN
  WORK_ITEM_COLLECT_PIN: true,
  // 工作项 - BriefOperation
  WORK_ITEM_BRIEF_OPERATION: true,
  // 工作项 - 节点卡片
  WORK_ITEM_NODE_CARD: true,
  // 评论 at人
  COMMENT_MENTION: true,
  // 工作项完成后 - 再发起评论
  COMMENT_WHEN_FINISHED: true,
};
